import ChatBot from "react-simple-chatbot";
import { useState } from "react";
import { ThemeProvider } from "styled-components";
import {
  ChatboatContext,
  ChatboatContextProvider,
} from "../../contexts/ChatboatContext";

import React from "react";

function ChatbotControl(props) {
  // Creating our own theme
  const theme = {
    background: "white",
    headerBgColor: "#ec2e7a",
    headerFontSize: "20px",
    botBubbleColor: "#59595b",
    headerFontColor: "white",
    botFontColor: "white",
    userBubbleColor: "#9c9c9c",
    userFontColor: "white",
    right: "10px",
  };

  const pageCount = 2;
  let currentPage = 1;
  let charId = 1;
  const [chatKey, setChatKey] = useState(1);
  const [chatopen, setChatopen] = useState(false);

  const data = [
    { id: 1, question: "What is your name?", answer: "My name is test" },
    { id: 2, question: "What is your age?", answer: "My age is 32" },
    {
      id: 3,
      question: "What is your pet name?",
      answer: "My pet name is test 1",
    },
    {
      id: 4,
      question: "What is your friend name?",
      answer: "My friend name is test 2",
    },
    {
      id: 5,
      question: "What is your friend name 1?",
      answer: "My friend name is test 2 2",
    },
  ];

  var [stepsDynamic, setStepsDynamic] = useState([
    {
      id: "1",
      message: "Hi, Greetings?, Please select your query:",
      trigger: "2",
    },
    {
      id: "2",
      options: [],
      asMessage: true,
    },
    {
      id: "3",
      message: "Do you want to continue with other queries?",
      trigger: "4",
    },
    {
      id: "4",
      options: [
        { value: "1", label: "Yes", trigger: "2" },
        { value: "2", label: "No", trigger: "5" },
      ],
    },
    {
      id: "5",
      message:
        "Thank you for chatting with us today! If you have any more questions or need further assistance, feel free to reach out anytime. Have a great day!",
      trigger: "6",
    },
    {
      id: "6",
      options: [{ value: "1", label: "Start again", trigger: "1" }],
    },
  ]);

  const steps = [
    {
      id: "1",
      message: "Hi, Greetings?, Please select your query:",
      trigger: "2",
    },
    {
      id: "2",
      options: [],
    },
    {
      id: "3",
      message: "Do you want to continue with other queries?",
      trigger: "4",
    },
    {
      id: "4",
      options: [
        { value: "1", label: "Yes", trigger: "2" },
        { value: "2", label: "No", trigger: "5" },
      ],
    },
    {
      id: "5",
      message:
        "Thank you for chatting with us today! If you have any more questions or need further assistance, feel free to reach out anytime. Have a great day!",
      trigger: "6",
    },
    {
      id: "6",
      component: (
        <div
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={(e) => {
            e.stopPropagation();
            setStepsDynamic(generateSource(steps));
            charId += 1;
            setChatKey(charId);
          }}
        >
          Start again
        </div>
      ),
      // options: [
      //   {
      //     value: "1",
      //     label: (' Start again'
      //       // <div
      //       //   onClick={(e) => {
      //       //     e.stopPropagation();
      //       //     setStepsDynamic(generateSource(steps));
      //       //     charId += 1;
      //       //     setChatKey(charId);
      //       //   }}
      //       // >
      //       //   Start again
      //       // </div>
      //     ),
      //     trigger: "1",
      //     asMessage: true,
      //   },
      // ],
      asMessage: true,
    },
  ];
 // const [isLoaded, setLoaded] = useState(false);

  const generateSource = (steps, nextPage = 1) => {
    const endValue = nextPage * pageCount;
    const newData = data.slice(endValue - pageCount, endValue);

    let mySteps = steps;
    const options = [];

    newData.forEach((question, index) => {
      if (options.length === pageCount) {
        return;
      }
      options.push({
        value: `${index + 1}`,
        label: question.question,
        trigger: `${mySteps.length + 1}`,
      });
      mySteps.push({
        id: `${mySteps.length + 1}`,
        message: question.answer,
        trigger: "3",
      });
    });
    options.push({
      id: `${options.length + 1}`,
      label: "Others",
      trigger: ({ value, steps1 }) => {
        currentPage += 1;
        setStepsDynamic(generateSource(steps, currentPage));
        charId += 1;
        setChatKey(charId);
        return false;
      },
    });
    if (newData.length === 0) {
      currentPage = 1;
      mySteps = generateSource(steps, currentPage);
    } else {
      mySteps[1].options = options;
    }
    return mySteps;
  };

  // useEffect(() => {
  //   // setStepsDynamic(generateSource(steps));
  //   // setLoaded(true);
  // }, [isLoaded]);

  const toogle = (opened) => {
    setChatopen(opened);
  };

  return (
    <ChatboatContextProvider>
      <ChatboatContext.Consumer>
        {(context) => (
          <div className="chatbox-popup">
            {(context.stepsDynamic ?? []).length > 0 ? (
              <ThemeProvider theme={theme}>
                <ChatBot
                  headerComponent={
                    <div
                      key={1}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: 50,
                        padding: 10,
                        backgroundColor: "#ec2e7a",
                      }}
                    >
                      <h3
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          fontSize: 24,
                        }}
                      >
                        Swallow
                      </h3>

                      <button
                        style={{ padding: 0, paddingRight: 10 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setChatopen(false);
                        }}
                      >
                        <img
                          alt=""
                          style={{ width: 15 }}
                          src="/assets/images/icon-close.png"
                        ></img>
                      </button>
                    </div>
                  }
                  toggleFloating={toogle}
                  opened={chatopen}
                  key={context.chatId}
                  headerTitle={"Swallow"}
                  botAvatar={"/assets/images/favicon.png"}
                  avatarStyle={{ width: 50 }}
                  inputStyle={{ visibility: "hidden" }}
                  hideSubmitButton
                  floating
                  steps={context.stepsDynamic}
                  // botDelay={2000}
                />
              </ThemeProvider>
            ) : (
              <></>
            )}
          </div>
        )}
      </ChatboatContext.Consumer>
    </ChatboatContextProvider>
  );
}

export default ChatbotControl;
